export default {
  common: {
    lang: 'English',
    showcase: 'Showcase',
    training: 'Training',
    generate: 'Generate',
    textGenerate: 'Text',
    imgGenerate: 'Image',
    videoGenerate: 'Video',
    modelGenerate: 'Model',
    settings: 'Settings',
    logout: 'logout'
  },
  notify: {
    notify: 'Notify',
    inputUsername: 'Enter username',
    inputPassword: 'Enter password',
    pwdCheckFailed: 'Entered passwords differ',
    SignSuccess: 'Register successfully',
    usernameNullError: 'The username cannot be blank.',
    usernameExistsError: 'The user name is already used',
    inputPasswordAgain: 'Please enter your password again',
    twicePwdCheckFailed: 'Entered passwords differ',
    emailNullFailed: 'Mailbox account cannot be empty!',
    emailError: 'Please enter the correct email address!',
    inputName: 'Enter your name',
    inputCity: 'Enter city you live',
    inputOrganization: 'Enter work or school',
    inputJob: 'Enter your occupation',
    inputEmail: 'Enter your email address',
    inputPhone: 'Enter your phone number',
    activeNotify: 'Do you want to send an email to activate the account? Note that emails can only be sent once a minute.',
    sendSuccess: ' delivery succeeded',
    activeSubmitSuccess: 'Delivery succeeded. Please activate your account after receiving the email.',
    dataSubmitted: 'Data submitted.',
    imageOnly: 'Only png/jpg images are supported'
  },
  user: {
    signTitle: 'User register',
    returnPwdTitle: 'Reset password',
    loginTitle: 'Log In',
    username: 'User Name',
    password: 'Password',
    forgetPassword: 'Forget password?',
    sign: 'Sign',
    login: 'Login',
    confirmPassword: 'Confirm password',
    name: 'Name',
    city: 'City',
    organization: 'Employer',
    job: 'Occupation',
    email: 'Email',
    phone: 'Phone Number',
    newPassword: 'new password',
    signEmail: 'email',
    fuGeneratorLabelP1: 'FUGenerator',
    fuGeneratorLabelP2: 'Customize your own design',
    fuGeneratorLabelP3: 'With Artificial Intelligence',
    fuGeneratorLabelP4: 'LEARN MORE',
  },
  generate: {
    hi: 'Hi ',
    headP: 'Architectural Design Generate!',
    previousStep: 'Previous Step',
    clearPanel: 'Clear Pane',
    input: 'Input',
    generation: 'Generation',
    output: 'Output',
    semanticInput: 'Semantic Input',
    englishPrompts: 'English prompts',
    selectSemanticOrInput: 'Select Semantic Or Input',
    guidedInput: 'Guided Input',
    upload: 'Upload',
    preProcess: 'Pre-process',
    imageInput: 'Image Input',
    imageInformation: 'Image information',
    semanticGeneration: 'Semantic Generation',
    semantic: 'Semantic',
    guided: 'Guided',
    models: 'Models',
    width: 'Width',
    height: 'Height',
    seed: 'Seed',
    imageGeneration: 'Image Generation',
    image: 'Image',
    rendergraphGen: "Sketch2RenderGen",  // 线稿 → 渲染图
    Img2RenderGen: "Img2RenderGen",  // 参考图 → 渲染图
    imageDescriptionGen: 'Image Description',  // 描述生成
    imageDescription: 'Image Description',  // 图片描述
    generateBtn: 'Generate',
    sendBtn: 'sending...',
    imageUpscalar: 'Image Upscalar',
    inpaint: 'Inpaint Generation',
    resolution: 'Resolution',
    descriptionOutput: 'Description Output',  // 文本输出
    SendToSemanticInput: 'Send to Semantic Input',
    imageOutput: 'Image Output',
    sendToImageInput: 'Send to Image Input',
    SendToGuidedInput: 'Send to Guided Input',
    origin: 'Original',
    originV2: 'originV2',
    birdsEye: 'Aerial',
    business: 'Commercial',
    indoor: 'Interior',
    model: 'Model',
    highRise: 'Skyscraper',
    imagePrefix: 'Image',
    none: 'none',
    architecture: 'architecture',
    real: 'real',
    render: 'render',
    cartoon: 'cartoon',
    image1: 'Image 1',
    image2: 'Image 2',
    image3: 'Image 3',
    textDesc: 'Text description',
    imgDesc: 'Image description',
    dragToArea: 'Drag to the area',
    uploadDire: 'Upload',
    baseModel: 'BASE',
    extraModel: 'ADDITIONAL',
    numFrames: 'FRAMES',
    downloadToLocal: 'DOWNLOAD',
    videoWH: 'SIZE W/H',
    share: 'SHARE',
    bgClear: 'Background clearing',
    uploadHandle: 'Handle',
    semanticDialog: {
      space: 'Space',
      composition: 'Composition',
      description: 'Description',
      Main: 'Main',
      Space: 'Space',
      Form: 'Form',
      Programme: 'Programme',
      Elements: 'Elements',
      Properties: 'Properties',
      Layout: 'Layout',
      Ratio: 'Ratio',
      Composition: 'Composition',
      Stream: 'Stream',
      Style: 'Style',
      Perspective: 'Perspective',
      Atmosphere: 'Atmosphere',
      Architect: 'Architect',
      Stylist: 'Stylist',
    },
    modelsDialog: {
      baseModel: 'BASE Model',
      vaeModel: 'VAE Model',
      loraModel: 'LORA Model',
      controlPreprocessorModel: 'Control Preprocessor Model',
    }
  },
  training: {
    headP: 'Customize Your Own Model!'
  },
  showcase: {
    sortByTime: 'Time sorting',
    sortByHot: 'Hot sort',
    textGen: 'Semantic Generation',
    noMore: 'No more ~',
    viewMore: 'view more',
    shareInfoDialog: {
      noImgInput: 'No image input',
      algorithm: "Algorithm",
      Seed: "Seed",
      Width: 'Width',
      Height: 'Height',
      Models: "Models",
      CFGScale: 'Semantic',
      ImgInput: 'Image Input',
      ControlImg: 'Guided Input',
      PoPrompts: "PoPrompts",
      LoraAlpha: 'LoraAlpha',
      NoiseLevel: 'Resolution',
      ControlScale: 'Guided',
      ImgStrengths: 'Image',
      algorithms : {
        txtGenerate: 'Semantic Generation',
        imgGenerate: 'Image Generation',
        Img2Prompts: 'Image Description',
        Superresolution: 'Image Upscalar',
        Inpaint: 'Inpaint Generation'
      },
      models: {
        '商业': 'Commercial',
        '原始': 'Original',
        '鸟瞰': 'Aerial',
        '室内': 'Interior',
        '超高层': 'Skyscraper',
        '模型': 'Model'
      }
    }
  },
  textInput: {
    inputZhOrEn: 'Enter chinese or english prompts',
    transContent: 'Translated content',
    poPromptsContent: 'Semantic Input',
    inputUsername: 'enter username',
    inputNewPwd: 'enter new password',
    inputPwdAgain: 'enter password again',
    inputSingEmail: 'enter your registration email'
  },
  btn: {
    trans: 'Translate',
    add: 'Add',
    ok: 'OK',
    reset: 'Reset',
    submit: 'Submit',
    confirm: 'Confirm',
    cancel: 'Cancel',
    download: 'Download',
    select: 'select'
  }
}
